"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTHORIZE_RESPONSE_CODE = void 0;
const APPROVED = '1';
const DECLINED = '2';
const ERROR = '3';
const HELD_FOR_REVIEW = '4';
exports.AUTHORIZE_RESPONSE_CODE = {
    APPROVED,
    DECLINED,
    ERROR,
    HELD_FOR_REVIEW
};
//# sourceMappingURL=authorizeResponseCode.js.map